import { TokenUserRoleType, USER_ROLE_LABEL_MAP, USER_ROLE_MAP, UserRoleType } from '@/const/user';
import { sessionStorageService } from './storageHelpers';
import { CURRENT_ROLE_KEY } from '@/const/shared';
import { SelfUserDetailsType } from '@/api/v1/users/getSelfUserDetailsApi';
import { isNullOrUndefined } from '@/helpers/objectHelpers';

export const getStorageCurrentRole = () => {
  const currentRole: UserRoleType = sessionStorageService.get(CURRENT_ROLE_KEY);

  return currentRole;
};

export const setStorageCurrentRole = (role: UserRoleType) => {
  sessionStorageService.set(CURRENT_ROLE_KEY, role);
};

export const getOrganizationName = (user: SelfUserDetailsType) => {
  if (!user || !user?.organization_user) return '';

  return user?.organization_user?.organization?.name || '';
};

export const getOrganizationRole = (user: SelfUserDetailsType) => {
  if (!user || !user?.organization_user) return;

  return user?.organization_user?.role;
};

export const getUserRoleLabel = (currentRole: UserRoleType) => {
  return USER_ROLE_LABEL_MAP[currentRole];
};

export const getRolesList = (roles: TokenUserRoleType): UserRoleType[] => {
  if (!roles) return [];

  return Object.values(roles);
};

export const hasRole = (user: SelfUserDetailsType, role: UserRoleType | UserRoleType[]) => {
  if (!user) return false;

  const roles = getRolesList(user.active_roles);

  return roles.find((userRole) => {
    return role.includes(userRole);
  });
};

export const hasMultipleRoles = (roles: TokenUserRoleType) => {
  if (!roles) return;

  return Object.keys(roles)?.length > 1;
};

export const getFirstRole = (roles: TokenUserRoleType) => {
  if (!roles) return;

  return Object.values(roles)?.[0];
};

export const getIsAvailableToAssign = (availableToAssign: boolean) => {
  if (isNullOrUndefined(availableToAssign)) return true;

  return !!availableToAssign;
};

export const isMasterAdminRole = (user: SelfUserDetailsType) => {
  if (!user) return false;

  return user.organization_user?.role === USER_ROLE_MAP.MASTER_ADMIN;
};

export const isAcceptedMasterServiceAgreement = (user: SelfUserDetailsType) => {
  if (!user) return false;

  return user?.organization_user?.organization?.is_msa_confirmed;
};
